import * as React from "react";

export interface ITextGroup {
  title?: any;
  noMarginBottom?: boolean;
}

export const InputContainerContext = React.createContext({} as ITextGroup);
